class SubscriptionWidget extends HTMLElement {
    constructor() {
        super();

        this.toggleBtn = this.querySelector('.subscription-widget__toggle');
        this.subContent = this.querySelector('.subscription-widget__content');
        this.variantSelects = document.querySelectorAll('.main-product__block-variant_picker .variant-picker__option');
        this.atcSelector = document.querySelector('.sticky-atc-wrapper .sticky-atc-variant-select');
        this.productId = this.dataset.productId;
        this.isSubscriptionActive = this.dataset.subscriptionActive === 'true';

        this.mobileOfferCard = document.querySelector('[data-mobile-offer-card]');
        this.mobileOfferPrice = document.querySelector('[data-mobile-offer-price]');
        this.mobileOfferMeta = document.querySelector('[data-mobile-offer-meta]');
        this.mobileOfferAdd = document.querySelector('[data-mobile-offer-add]');
        this.mainAtcButton = document.querySelector('.add-to-cart');

        this.mainProductWrapper = document.querySelector('.main-product-wrapper');
        this.mobileMediaQuery = window.matchMedia('(max-width: 767px)');
        this.mobileOfferObserver = null;
        this.footerObserver = null;

        this.addWidgetEventListener();
        this.addVariantEventListener();
        this.addStickyAtcEventListener();

        this.addMobileOfferEventListener();
        this.initMobileOfferVisibility();

        if (this.isSubscriptionActive) {
            this.onSubscriptionActive();
        } else {
            this.onOneTimeActive();
        }
    }

    // connectedCallback() {
    //     document.querySelector("variant-picker-new")?.addEventListener("mouseup", () => {
    //         setTimeout(() => {
    //             if (this.isSubscriptionActive) {
    //                 this.onSubscriptionActive();
    //             } else {
    //                 this.onOneTimeActive();
    //             }
    //         }, 100);
    //     });

    //      // Initialize the forced default 6 Month option
    //     // setTimeout(() => {
    //     //     const selectedInput = this.querySelector(
    //     //         'variant-button input[type="radio"]:checked'
    //     //     );

    //     //     if (selectedInput) {
    //     //         alert(selectedInput,"")
    //     //         selectedInput.dispatchEvent(
    //     //             new Event('change', { bubbles: true })
    //     //         );
    //     //     }
    //     // }, 100);
    // }

connectedCallback() {
    /*
    =====================================
    INITIAL LOAD
    DEFAULT = SUBSCRIPTION
    =====================================
    */

    if (this.isSubscriptionActive) {
        this.setVariantPrices();
    } else {
        this.setVariantPricesNoSubs();
    }


    /*
    =====================================
    FINAL LOAD SAFETY SYNC
    =====================================
    */

    window.addEventListener('load', () => {
        setTimeout(() => {
            console.log(
                '🔄 Final price mode sync:',
                this.isSubscriptionActive
                    ? 'subscription'
                    : 'one-time'
            );

            if (this.isSubscriptionActive) {
                this.setVariantPrices();
            } else {
                this.setVariantPricesNoSubs();
            }
        }, 300);
    });


    /*
    =====================================
    VARIANT CHANGE
    =====================================
    */

    document
        .querySelector('variant-picker-new')
        ?.addEventListener('mouseup', () => {
            setTimeout(() => {
                if (this.isSubscriptionActive) {
                    this.setVariantPrices();
                } else {
                    this.setVariantPricesNoSubs();
                }
            }, 150);
        });
}

    initMobileOfferVisibility() {
        if (!this.mobileOfferCard) return;

        const target = this.mainProductWrapper;
        const footer = document.querySelector('footer');

        if (!target) return;

        let isFooterVisible = false;

        const updateCardVisibility = (isProductVisible) => {
            if (!this.mobileMediaQuery.matches) {
                this.mobileOfferCard.classList.remove('is-visible');
                document.body.classList.remove('has-mobile-offer-card');
                return;
            }

            if (isFooterVisible) {
                this.mobileOfferCard.classList.remove('is-visible');
                document.body.classList.remove('has-mobile-offer-card');
                return;
            }

            if (isProductVisible) {
                this.mobileOfferCard.classList.remove('is-visible');
                document.body.classList.remove('has-mobile-offer-card');
            } else {
                this.mobileOfferCard.classList.add('is-visible');
                document.body.classList.add('has-mobile-offer-card');
            }
        };

        if (this.mobileOfferObserver) {
            this.mobileOfferObserver.disconnect();
        }

        this.mobileOfferObserver = new IntersectionObserver((entries) => {
            entries.forEach((entry) => {
                updateCardVisibility(entry.isIntersecting);
            });
        }, {
            root: null,
            threshold: 0.05
        });

        this.mobileOfferObserver.observe(target);

        if (footer) {
            if (this.footerObserver) {
                this.footerObserver.disconnect();
            }

            this.footerObserver = new IntersectionObserver((entries) => {
                entries.forEach((entry) => {
                    isFooterVisible = entry.isIntersecting;
                    const rect = target.getBoundingClientRect();
                    const isProductVisible = rect.bottom > 0 && rect.top < window.innerHeight;

                    updateCardVisibility(isProductVisible);
                });
            }, {
                root: null,
                threshold: 0.01
            });

            this.footerObserver.observe(footer);
        }

        const handleResize = () => {
            const rect = target.getBoundingClientRect();
            const isProductVisible = rect.bottom > 0 && rect.top < window.innerHeight;

            updateCardVisibility(isProductVisible);
        };

        this.mobileMediaQuery.addEventListener('change', handleResize);
        window.addEventListener('resize', handleResize);

        handleResize();
    }

    addMobileOfferEventListener() {
        if (!this.mobileOfferAdd) return;

        this.mobileOfferAdd.addEventListener('click', (e) => {
            e.preventDefault();

            window.scrollTo({
                top: 0,
                behavior: 'smooth'
            });
        });
    }

    updateMobileOfferCard() {
        if (!this.mobileOfferCard) return;

        const variant = this.getSelectedVariant();
        if (!variant) return;

        const dataset = variant.dataset;
        const oneTimePriceEl = variant.querySelector('.variant-picker-label__price-new');

        const oneTimePrice = oneTimePriceEl
            ? oneTimePriceEl.textContent.trim()
            : '';

        const subPrice = dataset.productSubPrice || '';
        const productCount = dataset.productCount || '';
        const modeLabel = this.isSubscriptionActive ? 'Subscription' : 'One-time purchase';
        const visiblePrice = this.isSubscriptionActive && subPrice ? subPrice : oneTimePrice;

        if (this.mobileOfferPrice) {
            this.mobileOfferPrice.textContent = visiblePrice;
        }

        if (this.mobileOfferMeta) {
            this.mobileOfferMeta.textContent = `${modeLabel}${productCount && productCount !== "0" ? ' • ' + productCount + ' Month' : ''}`;
        }
    }

    addWidgetEventListener() {
        if (!this.toggleBtn) return;

        this.toggleBtn.addEventListener('click', () => {
            this.isSubscriptionActive = !this.isSubscriptionActive;

            if (this.isSubscriptionActive) {
                this.onSubscriptionActive();
            } else {
                this.onOneTimeActive();
            }

            // Refresh the selected variant
            const variant = this.getSelectedVariant();
            if (variant) {
                this.onVariantChange(variant);
            }
        });
    }

    onOneTimeActive() {
        console.log('🔵 ONE-TIME ACTIVE');
        this.isSubscriptionActive = false;

        this.updateHeading();

        if (this.toggleBtn) {
            this.toggleBtn.classList.remove('active');
            this.toggleBtn.setAttribute('aria-pressed', 'false');
            this.toggleBtn.disabled = false;
        }

        if (this.subContent) {
            this.subContent.classList.remove('open');
        }

        this.setSellingPlanInProductForms(null);

        const subtotal = document.querySelector(".main-product__block-price .f-price__sale.subscription");
        if (subtotal) {
            subtotal.style.display = "none";
        }

        const subtotalCompare = document.querySelector(".main-product__block-price .f-price__sale:not(.subscription)");
        if (subtotalCompare) {
            subtotalCompare.style.display = "flex";
        }

        this.variantSelects.forEach((variant) => {
            const originalPrice = variant.querySelector(
                ".variant-picker-label-text:not(.subscription)"
            );

            const subPrice = variant.querySelector(
                ".variant-picker-label-text.subscription"
            );

            // One-time active
            if (subPrice) {
                subPrice.classList.add("hidden");
            }

            if (originalPrice) {
                originalPrice.classList.remove("hidden");
                originalPrice.style.removeProperty("display");
            }
        });

        const atcSubtotal = document.querySelector(".sticky-atc-wrapper .product-price-wrapper .sticky-atc-price.subscription");
        if (atcSubtotal) {
            atcSubtotal.classList.add("hidden");
        }

        const atcSubtotalCompare = document.querySelector(".sticky-atc-wrapper .product-price-wrapper .sticky-atc-price:not(.subscription)");
        if (atcSubtotalCompare) {
            atcSubtotalCompare.classList.remove("hidden");
        }

        this.setStickyAtcVariant(true);
        this.updateVariantSaveBadges('one-time');
        this.updateAtcButtonPrice();
        this.updateDetailContent();
        this.updateMobileOfferCard();
        this.setVariantPricesNoSubs();
    }

    onSubscriptionActive() {
        console.log('✅ SUBSCRIPTION ACTIVE');
        console.log('Calling setVariantPrices');
        this.isSubscriptionActive = true;
        this.updateHeading();

        if (this.toggleBtn) {
            this.toggleBtn.classList.add('active');
            this.toggleBtn.setAttribute('aria-pressed', 'true');
            this.toggleBtn.disabled = false;

            const selectedVariant = this.getSelectedVariant();
            if (selectedVariant?.dataset?.productSubPrice === "") {
                this.toggleBtn.disabled = true;
            }
        }

        if (this.subContent) {
            this.subContent.classList.add("open");
        }

        // const newSellingPlan = this.getSelectedVariant()?.dataset.sellingPlan;
        // if (newSellingPlan) {
        //     this.setSellingPlanInProductForms(newSellingPlan);
        // }
        const currentPlan = this.getCurrentVariantSellingPlan();
        if (currentPlan?.id) {
            this.setSellingPlanInProductForms(currentPlan.id);
        } else {
            this.setSellingPlanInProductForms(null);
        }

        this.setUspText();
        this.setSubtotal();
        this.setVariantPrices();
        this.setStickyAtcSubtotal();
        this.setStickyAtcVariant(false);
        this.updateVariantSaveBadges('subscription');
        this.updateAtcButtonPrice();
        this.updateDetailContent();
        this.updateMobileOfferCard();
    }

    setUspText() {
        const variant = this.getSelectedVariant();
        if (!variant) return;

        const planName = this.querySelector(".subscription-widget__content .selling-plan__name");
        if (planName) {
            planName.textContent = variant.dataset.planName || '';
        }
    }

    setSubtotal() {
        const variant = this.getSelectedVariant();
        if (!variant) return;

        const dataset = variant.dataset;
        const subPrice = dataset.productSubPrice;

        const priceDiv = document.querySelector(".main-product__block-price .f-price__sale:not(.subscription)");
        let subPriceDiv = document.querySelector(".main-product__block-price .f-price__sale.subscription");

        if (priceDiv && !subPriceDiv) {
            const compareAtDiv = priceDiv.querySelector(".prod__compare_price");
            const compareAtText = compareAtDiv ? compareAtDiv.textContent : "";

            this.renderSubscriptionPrice(
                priceDiv,
                `<div class="f-price__sale subscription">
                    <span class="visually-hidden visually-hidden--inline">Sale price</span>
                    <span class="f-price-item f-price-item--sale text-xl md:text-2xl prod__price text-color-regular-price">${subPrice}</span>
                    <span class="visually-hidden visually-hidden--inline">Regular price</span>
                    ${compareAtText ? `<s class="pl-2 f-price-item f-price-item--regular prod__compare_price line-through text-color-secondary flex items-center">${compareAtText}</s>` : ''}
                </div>`
            );

            subPriceDiv = document.querySelector(".main-product__block-price .f-price__sale.subscription");
        }

        if (priceDiv) {
            priceDiv.style.display = "none";
        }

        if (subPriceDiv) {
            const saleNode = subPriceDiv.querySelector(".f-price-item--sale");
            if (saleNode) saleNode.textContent = subPrice;
            subPriceDiv.style.display = "flex";
        }
    }

    getSavePercent({
            basePrice,
            currentPrice,
            fallbackBasePerItem,
            fallbackCurrentPerItem
        }) {
        const base = parseFloat(this.cleanPrice(basePrice || ''));
        const current = parseFloat(this.cleanPrice(currentPrice || ''));

        if (!isNaN(base) && !isNaN(current) && base > current && current > 0) {
            return Math.round(((base - current) / base) * 100);
        }

        const fallbackBase = parseFloat(this.cleanPrice(fallbackBasePerItem || ''));
        const fallbackCurrent = parseFloat(this.cleanPrice(fallbackCurrentPerItem || ''));

        if (!isNaN(fallbackBase) && !isNaN(fallbackCurrent) && fallbackBase > fallbackCurrent && fallbackCurrent > 0) {
            return Math.round(((fallbackBase - fallbackCurrent) / fallbackBase) * 100);
        }

        return 0;
    }

    updateVariantSaveBadges(mode = 'one-time') {
        if (!this.variantSelects) return;

        this.variantSelects.forEach((variant) => {
            const dataset = variant.dataset;

            const headingWrap = variant.querySelector(".variant-picker-label__heading-wrap");
            let saveEl = variant.querySelector(".variant-save-dynamic");
            const saveElDefault = variant.querySelector(".variant-save--default");

            if (headingWrap && !saveEl) {
                headingWrap.insertAdjacentHTML(
                    "beforeend",
                    `<span class="variant-save variant-save-dynamic hidden"></span>`
                );
                saveEl = variant.querySelector(".variant-save-dynamic");
            }

            if (!saveEl) return;

            let savePercent = 0;

            if (mode === 'subscription') {
                const comparePrice = dataset.comparePrice || '';
                const subPrice = dataset.productSubPrice || '';

                const subPricePerItem = dataset.productSubPricePi || '';
                const basePriceRaw =
                    variant.getAttribute('data-base-price-pi-raw') ||
                    dataset.basePricePiRaw ||
                    '';

                const hasComparePrice =
                    comparePrice &&
                    comparePrice.trim() !== '' &&
                    comparePrice !== subPrice;

                if (hasComparePrice) {
                    savePercent = this.getSavePercent({
                        basePrice: comparePrice,
                        currentPrice: subPrice
                    });
                } else {
                    savePercent = this.getSavePercent({
                        fallbackBasePerItem: basePriceRaw,
                        fallbackCurrentPerItem: subPricePerItem
                    });
                }
            } else {
                const comparePrice = dataset.comparePrice || '';
                const oneTimePrice =
                    variant.querySelector(".variant-picker-label__price-new")?.textContent.trim() || '';

                const basePriceRaw = variant.getAttribute('data-base-price-pi-raw') || dataset.basePricePiRaw || '';
                const currentPricePi = dataset.currentPricePiRaw || dataset.currentPricePi || '';

                savePercent = this.getSavePercent({
                    basePrice: comparePrice,
                    currentPrice: oneTimePrice,
                    fallbackBasePerItem: basePriceRaw,
                    fallbackCurrentPerItem: currentPricePi
                });
            }

            if (savePercent > 0) {
                saveEl.textContent = `Save ${savePercent}%`;
                saveEl.classList.remove("hidden");
            } else {
                saveEl.textContent = "";
                saveEl.classList.add("hidden");
            }

            if (saveElDefault) {
                saveElDefault.classList.add("hidden");
            }
        });
    }

setVariantPrices() {
    if (!this.variantSelects) return;

    console.log('🟢 setVariantPrices() START');

    this.variantSelects.forEach((variant) => {
        const dataset = variant.dataset;

        const variantPriceDiv = variant.querySelector(
            '.variant-picker-label-text:not(.subscription)'
        );

        const variantTotalPriceNoSubs = variant.querySelector(
            '.variant-picker-label__price-wrap'
        );

        let variantSubPriceDiv = variant.querySelector(
            '.variant-picker-label-text.subscription'
        );

        const subPricePerItem = dataset.productSubPricePi;
        const subPrice = dataset.productSubPrice;
        const subComparePrice = dataset.comparePrice;
        const currentUnit = dataset.currentUnit || '';

        console.log('------------------------------');
        console.log('Variant:', dataset);
        console.log('Subscription price:', subPrice);
        console.log('Subscription price per item:', subPricePerItem);
        console.log('Current unit:', currentUnit);
        console.log('One-time price div:', variantPriceDiv);
        console.log('Existing subscription div:', variantSubPriceDiv);

        /*
        ==========================================
        CREATE / UPDATE SUBSCRIPTION PRICE HTML
        ==========================================
        */

        if (
            subPrice &&
            subPrice !== '' &&
            dataset.productCount &&
            dataset.productCount !== '0'
        ) {
            const regularPrice =
            dataset.productCurrentPrice ||
            dataset.currentPrice ||
            '';
            // const regularPrice =
            //     variant
            //         .querySelector('.variant-picker-label__price-new')
            //         ?.textContent.trim() || '';

            // const hasNativeComparePrice =
            //     !!subComparePrice &&
            //     subComparePrice.trim() !== '';

            // const comparePriceToShow =
            //     hasNativeComparePrice
            //         ? subComparePrice
            //         : regularPrice;

            // const hasDiscountPrice =
            //     !!comparePriceToShow &&
            //     comparePriceToShow !== subPrice;

            // const comparePriceToShow = regularPrice;
    // const comparePriceToShow = regularPrice;
    //         const comparePriceToShow =
    // dataset.subscriptionComparePrice ||
    // dataset.comparePrice ||
    // '';
const productCount = parseInt(dataset.productCount, 10);

    let comparePriceToShow = '';

    if (productCount === 1) {
        comparePriceToShow = dataset.subscriptionComparePrice || '';
    } else if ([2, 3, 6].includes(productCount)) {
        comparePriceToShow = dataset.comparePrice || '';
    }

    // const hasDiscountPrice =
    //     !!comparePriceToShow &&
    //     comparePriceToShow !== subPrice;
    const compareValue = parseFloat(this.cleanPrice(comparePriceToShow));
    const subValue = parseFloat(this.cleanPrice(subPrice));

    const hasDiscountPrice =
    !isNaN(compareValue) &&
    !isNaN(subValue) &&
    compareValue > subValue;

    /*
    CREATE SUBSCRIPTION PRICE
    */

    if (variantPriceDiv && !variantSubPriceDiv) {
        this.renderSubscriptionPrice(
    variantPriceDiv,
    `
    <div class="font-normal variant-picker-label-text subscription">
        <div class="price-per-bottle-wrap">
            <span>${subPricePerItem || subPrice}</span>
            ${currentUnit ? ` / per ${currentUnit}` : ''}
        </div>

        <div class="price-subs-total-wrap">
            ${
                hasDiscountPrice
                    ? `
                    <span class="price-subs-total-wrap__compare-price line-through">
                        ${comparePriceToShow}
                    </span>
                    `
                    : ''
            }

            <span class="price-subs-total-wrap__new">
                ${subPrice}
            </span>
        </div>
    </div>
    `
);

                variantSubPriceDiv = variant.querySelector(
                    '.variant-picker-label-text.subscription'
                );
            }

            /*
            UPDATE EXISTING SUBSCRIPTION PRICE
            */

            else if (variantSubPriceDiv) {
                const compareNode =
                    variantSubPriceDiv.querySelector(
                        '.price-subs-total-wrap__compare-price'
                    );

                const newPriceNode =
                    variantSubPriceDiv.querySelector(
                        '.price-subs-total-wrap__new'
                    );

                const perItemNode =
                    variantSubPriceDiv.querySelector(
                        '.price-per-bottle-wrap span'
                    );

                const totalWrap =
                    variantSubPriceDiv.querySelector(
                        '.price-subs-total-wrap'
                    );

                if (compareNode && hasDiscountPrice) {
                    compareNode.textContent =
                        comparePriceToShow;
                }

                if (compareNode && !hasDiscountPrice) {
                    compareNode.remove();
                }

                if (
                    !compareNode &&
                    hasDiscountPrice &&
                    totalWrap
                ) {
                    totalWrap.insertAdjacentHTML(
                        'afterbegin',
                        `
                        <span class="price-subs-total-wrap__compare-price line-through">
                            ${comparePriceToShow}
                        </span>
                        `
                    );
                }

                if (newPriceNode) {
                    newPriceNode.textContent =
                        subPrice;
                }

                if (perItemNode) {
                    perItemNode.textContent =
                        subPricePerItem || subPrice;
                }
            }
        }

        /*
        ==========================================
        IMPORTANT:
        ALWAYS APPLY SUBSCRIPTION VISIBILITY
        ==========================================
        */

        variantSubPriceDiv = variant.querySelector(
            '.variant-picker-label-text.subscription'
        );

        if (variantPriceDiv) {
            variantPriceDiv.classList.add('hidden');
        }

        if (variantTotalPriceNoSubs) {
            variantTotalPriceNoSubs.classList.add('hidden');
        }

        if (variantSubPriceDiv) {
            variantSubPriceDiv.classList.remove('hidden');
        }

        console.log('✅ Subscription mode applied');
    });

    this.updateVariantSaveBadges('subscription');

    console.log('🟢 setVariantPrices() END');
}

    updateHeading() {
        const heading = document.getElementById('subscription-heading');
        if (!heading) return;

        // heading.textContent = this.isSubscriptionActive
        //     ? heading.dataset.subscription
        //     : heading.dataset.oneTime;
    }

    setStickyAtcSubtotal() {
        const variant = this.getSelectedVariant();
        if (!variant) return;

        const dataset = variant.dataset;
        const subPrice = dataset.productSubPrice;

        const priceDiv = document.querySelector(".sticky-atc-wrapper .product-price-wrapper .sticky-atc-price:not(.subscription)");
        let subPriceDiv = document.querySelector(".sticky-atc-wrapper .product-price-wrapper .sticky-atc-price.subscription");

        if (priceDiv && !subPriceDiv) {
            this.renderSubscriptionPrice(priceDiv, `<div class="sticky-atc-price subscription">${subPrice}</div>`);
            subPriceDiv = document.querySelector(".sticky-atc-wrapper .product-price-wrapper .sticky-atc-price.subscription");
        }

        if (priceDiv) {
            priceDiv.classList.add("hidden");
        }

        if (subPriceDiv) {
            subPriceDiv.textContent = subPrice;
            subPriceDiv.classList.remove("hidden");
        }
    }

    setStickyAtcVariant(resetPrice) {
        if (!this.atcSelector) return;

        this.atcSelector.querySelectorAll("option").forEach((option) => {
            const dataset = option.dataset;

            if (dataset.productSubPricePi !== "" && dataset.productCount !== "" && dataset.productCount !== "0") {
                const subPricePerItem = dataset.productSubPricePi;
                const originalPricePerItem = dataset.currentPricePi;

                option.textContent = `${dataset.value.split("-")[0]} - ${resetPrice ? originalPricePerItem : subPricePerItem} ${dataset.currentUnit}`;
            }
        });
    }

    addVariantEventListener() {
        if (!this.variantSelects) return;

        this.variantSelects.forEach((variant) => {
            variant.addEventListener('click', () => {
                setTimeout(() => {
                    const selectedVariant = this.getSelectedVariant();
                    if (selectedVariant) {
                        this.onVariantChange(selectedVariant);
                    }
                }, 100);
            });
        });
    }

    addStickyAtcEventListener() {
        if (!this.atcSelector) return;

        this.atcSelector.addEventListener('change', () => {
            const variant = this.getSelectedVariant();
            if (!variant) return;

            const dataset = variant.dataset;
            const variantSelector = document.querySelector(".main-product__block-variant_picker variant-button");

            if (variantSelector) {
                variantSelector.setAttribute("data-selected-value", dataset.value);
            }

            this.onVariantChange(variant);
        });
    }

getCurrentVariantSellingPlan(variantId = null) {
    if (!variantId) {
        const productInputs = document.querySelectorAll('input[name="product-id"]');

        const productInput = Array.from(productInputs).find(
            (input) => input.value === this.productId
        );

        const form = productInput?.closest('form');
        variantId = form?.querySelector('input[name="id"]')?.value;
    }

    if (!variantId) {
        console.log('No current variant ID found');
        return null;
    }

    const sellingPlansScript = document.querySelector(
        'script[id^="productSellingPlans-"]'
    );

    if (!sellingPlansScript) {
        console.log('Selling plans JSON not found');
        return null;
    }

    let sellingPlansData;

    try {
        sellingPlansData = JSON.parse(sellingPlansScript.textContent);
    } catch (error) {
        console.error('Unable to parse selling plan data:', error);
        return null;
    }

    const variantPlans = sellingPlansData[String(variantId)] || [];

    console.log('Variant ID:', variantId);
    console.log('Available selling plans:', variantPlans);

    return variantPlans[0] || null;
}

    // getCurrentVariantSellingPlan() {
    //     const variantPicker = document.querySelector("variant-picker-new");
    //     const currentVariant = variantPicker?.currentVariant;

    //     if (!currentVariant?.id) return null;

    //     const sellingPlansScript = document.querySelector(
    //         'script[id^="productSellingPlans-"]'
    //     );

    //     if (!sellingPlansScript) return null;

    //     let sellingPlansData;

    //     try {
    //         sellingPlansData = JSON.parse(sellingPlansScript.textContent);
    //     } catch (error) {
    //         console.error("Unable to parse selling plan data:", error);
    //         return null;
    //     }

    //     const variantPlans = sellingPlansData[String(currentVariant.id)] || [];

    //     if (!variantPlans.length) return null;

    //     return variantPlans[0];
    // }

    // getSelectedVariant() {
    //     return document.querySelector(`.main-product__block-variant_picker .variant-picker__option:has(input:checked)`);
    // }
    // getSelectedVariant() {
    //     return document.querySelector(
    //         `.main-product__block-variant_picker variant-button .variant-picker__option:has(input:checked)`
    //     );
    // }

    getSelectedVariant() {
        return document.querySelector(
            `.main-product__block-variant_picker variant-button .variant-picker__option:has(input:checked)`
        );
    }

    updateCustomVariantPrice(variant) {
        if (!variant) return;

        const priceElement = document.querySelector(
            '.custom-selected-variant-price'
        );

        if (!priceElement) return;

        const price =
            variant.dataset.productCurrentPrice ||
            variant.dataset.currentPrice ||
            variant.querySelector('.variant-picker-label__price-new')?.textContent.trim();

        if (price) {
            priceElement.textContent = price;
        }
    }

    onVariantChange(variant) {
        const dataset = variant.dataset;

        this.updateCustomVariantPrice(variant);

        if (dataset.productSubPrice !== "" && dataset.productCount !== "" && dataset.productCount !== "0") {
            const subPrice = dataset.productSubPrice;

            const subtotal = document.querySelector(".main-product__block-price .f-price__sale.subscription .f-price-item--sale");
            if (subtotal) subtotal.textContent = subPrice;

            const atcSubtotal = document.querySelector(".sticky-atc-wrapper .product-price-wrapper .sticky-atc-price.subscription");
            if (atcSubtotal) atcSubtotal.textContent = subPrice;
        }

        // if (this.isSubscriptionActive) {
        //     // this.dataset.sellingPlan = dataset.sellingPlan;
        //     // this.setSellingPlanInProductForms(dataset.sellingPlan);
        //     const currentPlan = this.getCurrentVariantSellingPlan();
        //     if (currentPlan?.id) {
        //         this.dataset.sellingPlan = currentPlan.id;
        //         this.setSellingPlanInProductForms(currentPlan.id);
        //     } else {
        //         this.dataset.sellingPlan = "";
        //         this.setSellingPlanInProductForms(null);
        //     }
        if (this.isSubscriptionActive) {

            const sellingPlanId = dataset.sellingPlan;

            console.clear();
            console.log("Variant ID:", dataset.variantId);
            console.log("Selling Plan ID:", sellingPlanId);

            if (sellingPlanId) {
                this.dataset.sellingPlan = sellingPlanId;
                this.setSellingPlanInProductForms(sellingPlanId);
            } else {
                this.dataset.sellingPlan = "";
                this.setSellingPlanInProductForms(null);
            }

            const planName = this.querySelector(".subscription-widget__content .selling-plan__name");
            if (planName) {
                planName.textContent = dataset.planName || '';
            }

            this.setSubtotal();
            this.setStickyAtcSubtotal();
            this.setStickyAtcVariant(false);
            this.updateVariantSaveBadges('subscription');

            requestAnimationFrame(() => {
                this.setVariantPrices();
            });
        }
        else {
            this.setStickyAtcVariant(true);
            this.updateVariantSaveBadges('one-time');
        }

        const variantPicker = document.querySelector("variant-picker-new");
        if (variantPicker) {
            variantPicker.updateButton(
                !variantPicker.currentVariant?.available,
                window.MinimogStrings.soldOut
            );
        }

        this.updateAtcButtonPrice();
        this.updateMobileOfferCard();
    }

    updateDetailContent() {
        const detailContents = document.querySelectorAll('.product-option-item__detail-content');

        if (!detailContents.length) return;

        detailContents.forEach((container) => {
            const oneTimeContent = container.querySelector('.detail-content--one-time');
            const subscriptionContent = container.querySelector('.detail-content--subscription');

            if (this.isSubscriptionActive) {
                if (oneTimeContent) oneTimeContent.classList.add('hidden');
                if (subscriptionContent) subscriptionContent.classList.remove('hidden');
            } else {
                if (oneTimeContent) oneTimeContent.classList.remove('hidden');
                if (subscriptionContent) subscriptionContent.classList.add('hidden');
            }
        });
    }

    updateAtcButtonPrice() {
        const variant = this.getSelectedVariant();
        if (!variant) return;

        const buttonTextWrap = document.querySelector('.add-to-cart .button__text-wrap');
        const atcPrice = document.querySelector('.add-to-cart .atc-price');
        const addButton = document.querySelector('.add-to-cart');

        if (!buttonTextWrap || !addButton) return;

        const addToCartText = addButton.dataset.atcText || 'Add to cart';
        const oneTimePriceEl = variant.querySelector('.variant-picker-label__price-new');

        if (this.isSubscriptionActive && variant.dataset.productSubPrice) {
            if (atcPrice) {
                atcPrice.textContent = variant.dataset.productSubPrice;
            } else {
                buttonTextWrap.textContent = `${addToCartText} • ${variant.dataset.productSubPrice}`;
            }
            return;
        }

        const oneTimePrice = oneTimePriceEl
            ? oneTimePriceEl.textContent.trim()
            : '';

        if (atcPrice) {
            atcPrice.textContent = oneTimePrice;
        } else if (oneTimePrice) {
            buttonTextWrap.textContent = `${addToCartText} • ${oneTimePrice}`;
        }
    }

    cleanPrice(priceString) {
        return String(priceString || '').replace(/[^0-9.-]+/g, "");
    }

    renderSubscriptionPrice(targetElement, innerHTML) {
        const newElement = document.createElement("div");
        newElement.innerHTML = innerHTML;
        targetElement.insertAdjacentHTML("afterend", newElement.innerHTML);
    }

    setSellingPlanInProductForms(sellingPlan) {
        const productInputs = document.querySelectorAll('input[name="product-id"]');
        if (!productInputs) return;

        const matchingInputs = Array.from(productInputs).filter((input) => input.value === this.productId);

        matchingInputs.forEach((input) => {
            const form = input.closest("form");
            if (!form) return;

            let sellingPlanInput = form.querySelector("input[name='selling_plan']");

            // if (sellingPlan === null || sellingPlan === "" || sellingPlan === "null") {
            if (
                !sellingPlan ||
                sellingPlan === "null" ||
                sellingPlan === "undefined" ||
                !/^\d+$/.test(String(sellingPlan))
            ) {
                if (sellingPlanInput) {
                    sellingPlanInput.remove();
                }
                return;
            }

            if (sellingPlanInput) {
                sellingPlanInput.value = sellingPlan;
                return;
            }

            sellingPlanInput = document.createElement("input");
            sellingPlanInput.type = "hidden";
            sellingPlanInput.name = "selling_plan";
            sellingPlanInput.value = sellingPlan;
            form.appendChild(sellingPlanInput);
        });
    }
}

customElements.define("subscription-widget", SubscriptionWidget);